
import React, { useState } from 'react';
import styles from '../../assets/scss/UserType.module.scss';
import inventoryStyles from '../../assets/scss/InventoryManagement/InventoryTable.module.scss';
import settingStyles from '../../assets/scss/Settings/Settings.module.scss';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../Components/Common/Pagination';
import { useDeleteUserTypeMutation, useUserTypeQuery } from '../../slices/admin/admin';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import { FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';

const UserType = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedUserTypeIndex, setSelectedUserTypeIndex] = useState(null);

  const rowsPerPage = 10;
  const offset = (currentPage - 1) * rowsPerPage + 1;

  const isActiveValue =
    selectedStatus === 'Active' ? true :
      selectedStatus === 'Inactive' ? false :
        undefined;

  const {
    data: apiData = {},
    isLoading,
    isError,
    error,
  } = useUserTypeQuery({
    offset,
    limit: rowsPerPage,
    isActive: isActiveValue,
    search: searchValue,
  });
  const [deleteUserType] = useDeleteUserTypeMutation();


  const userTypeData = apiData.result || [];
  const totalCount = apiData.total || 0;
  const totalPages = Math.ceil(totalCount / rowsPerPage);
  const navigate = useNavigate();

  const handlClickInvite = () => {
    navigate('/dashboard/UserTypes');
  };

  const handleDeleteClick = (index) => {
    setSelectedUserTypeIndex(index);
    setModalOpen(true);
  };

  const confirmDelete = async () => {
    if (selectedUserTypeIndex === null) return;

    const userToDelete = userTypeData[selectedUserTypeIndex];

    try {
      const response = await deleteUserType(userToDelete._id).unwrap();
      toast.success(response.message);
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to delete user type');
    }

    setModalOpen(false);
    setSelectedUserTypeIndex(null);
  };


  return (
    <div className={inventoryStyles.inventoryContainer}>
      <div className={settingStyles.headerRow}>
        <h2 className={settingStyles.header}>User Type</h2>
      </div>
      <div className={styles.main}>
        <div className={styles.topBar}>
          <div className={styles.filterContainer}>
            <input
              type="text"
              placeholder="Search User Type..."
              className={styles.searchInput}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setCurrentPage(1);
              }}
            />
            <select
              className={styles.statusSelect}
              value={selectedStatus}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
            <button
              className={styles.clearBtn}
              onClick={() => {
                setSearchValue('');
                setSelectedStatus('');
                setCurrentPage(1);
              }}
            >
              Clear All
            </button>
          </div>
          <div>
            <button className={styles.sendInvite} onClick={handlClickInvite}>
              + Add User Type
            </button>
          </div>
        </div>

        {/* Table */}
        {isLoading ? (
          <p>Loading...</p>
        ) : isError ? (
          <p>{error?.data?.message || 'Failed to load data'}</p>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                {/* <th><input type="checkbox" /></th> */}
                <th>User Type</th>
                <th>Description</th>
                <th>Effective Date</th>
                <th>Status</th>
                <th>Role Name</th>
                <th>Comments</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {userTypeData.length === 0 ? (
                <tr>
                  <td colSpan="8" className={styles.noData}>No record found</td>
                </tr>
              ) : (
                userTypeData.map((user, index) => (
                  <tr key={index}>
                    {/* <td><input type="checkbox" /></td> */}
                    <td>{user.usertype}</td>
                    <td>{user.description}</td>
                    <td>
                      {user.roleId?.effectiveDate
                        ? new Date(user.roleId.effectiveDate).toLocaleDateString()
                        : '--'}
                    </td>
                    <td className={user.isActive ? styles.active : styles.inactive}>
                      {user.isActive ? 'Active' : 'Inactive'}
                    </td>
                    <td>{user.roleId?.roleName || '--'}</td>
                    <td>{user.comments || '--'}</td>
                    <td>
                      <FaTrash className={styles.icon} onClick={() => handleDeleteClick(index)} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}

        {/* Pagination */}
        {!isLoading && !isError && totalCount > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}

        {/* Delete Confirm Modal */}
        <DeleteConfirmModal
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={confirmDelete}
        />
      </div>
    </div>
  );
};

export default UserType;


